
import { Component, Vue,Emit } from 'vue-property-decorator'
import Pagination from "@/components/Pagination/index.vue";
import { OrderRecordService, UpdateVipExpireDateInput } from '@/api/service-proxies'
import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { __param } from "tslib";
import moment from 'moment';
import { warn } from 'vue-class-component/lib/util';
import { orderRecordService } from '@/api/payments/order-record';

@Component
export default class VipDaysDialog extends Vue {
  private dialogVisible: boolean = false

  isSkipHolidays: boolean = false
  isExporting: boolean = false
  isAdd:boolean;
  id:string;
  studentName= "";
  className = "";
  faceImg= ""
  textStr = "增加"
  schoolId = 0
  addOrInduce = false
  adjuctVipNumber = 0
  public open(id, schoolId, studentName, className, faceImg) {
    console.log(id,schoolId)
    this.id = id
    this.schoolId = schoolId
    this.studentName = studentName;
    this.className = className;
    this.faceImg = faceImg;
    this.addOrInduce = false
    this.dialogVisible = true
  }
  errorHandler() {
    return true
  }
  close() {
    this.dialogVisible = false;
  }
  isAddOrInduce(type) {
    this.adjuctVipNumber=0;
    this.addOrInduce = true
    // add增加，induce减少
    if (type == 'add') {
      this.textStr = "增加"
      this.isAdd=true;
    } else {
      this.isAdd=false;
      this.textStr = "减少"
    }
  }
  // this.faceService.updateFeatures(id).then((result) => {
  //           this.$notify.success(result.replace('\"',''));
  //       });
  submit() {
    orderRecordService.updateVipExpireDate(new UpdateVipExpireDateInput({
      isAdd:this.isAdd,
      days:this.adjuctVipNumber,
      id :this.id,
      tenantId:this.schoolId,
    }))
    .then((result)=>{
      this.$message.success("调整成功")
      this.onSuccess()
    })
    .catch((e)=>{
      this.$message.error("调整失败")
    })
    .finally(()=>{
      this.dialogVisible=false;
    })
  }
  back() {
    this.addOrInduce = false
  }

  @Emit("success")
    private onSuccess() {}
}

